import { IEntity } from "./Entity";

export interface IApp03EpicEvidence extends IEntity {
    FileUniqueID?: string;
    Details?: string;
    EpicID?: number;
    DateCreated?: Date;
    AddedByUserID?: number;
    AttachmentType?: string;
}

export class App03EpicEvidence implements IApp03EpicEvidence {
    public ID: number = 0;
    public Title: string = null;
    public FileUniqueID?: string = null;
    public Details?: string = "";
    public EpicID?: number = null;
    public DateCreated?: Date = null;
    public AddedByUserID?: number = null;
    public AttachmentType?: string = null;

    constructor(epicID: number, attachmentType: string) {
        this.EpicID = epicID;
        this.AttachmentType = attachmentType;
    }
}